export const InfoRow = ({ label, value }) => (
  <div className="info-row">
    <span className="info-row__label">{label}</span>
    <span className="info-row__value">{value}</span>
  </div>
)

export default InfoRow
